/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsForRegex": ["^draft"] }] */
import { produce } from 'immer';

import {
  UPDATE_OCCUPATION,
  UPDATE_POLITICALLY_EXPOSED,
  UPDATE_ANNUAL_INCOME,
  actionTypes,
  UPDATE_REKYC_MODAL_STATE,
  UPDATE_RESTRICTION_INFO_MODAL,
} from 'actionTypes/rekycVerification';
import { API_STATUS, REKYC_FLOW } from 'constants/enums';
import { RekycVerification } from 'types/RekycVerification';

const initialState: RekycVerification = {
  occupation: null,
  detailsData: {
    loading: false,
    data: null,
  },
  politicallyExposed: null,
  annualIncome: null,
  rekycFlow: {
    apiStatus: API_STATUS.IDLE,
    data: null,
  },
  modalOpenSource: '',
  verificationModalOpen: false,
  restrictionsInfoModalOpen: false,
};

// eslint-disable-next-line default-param-last
const rekycVerification = produce((draft = initialState, action) => {
  switch (action.type) {
    case UPDATE_OCCUPATION:
      draft.occupation = action.payload.value;
      break;
    case UPDATE_POLITICALLY_EXPOSED:
      draft.politicallyExposed = action.payload.value;
      break;
    case UPDATE_ANNUAL_INCOME:
      draft.annualIncome = action.payload.value;
      break;
    case actionTypes['REKYC/GET_PROFILE_KYC_DETAILS'].LOAD:
      draft.detailsData.loading = true;
      break;

    case actionTypes['REKYC/GET_PROFILE_KYC_DETAILS'].FAIL:
      draft.detailsData.loading = false;
      break;

    case actionTypes['REKYC/GET_PROFILE_KYC_DETAILS'].SUCCESS:
      draft.detailsData.loading = false;
      draft.detailsData.data = action.result.result;
      break;

    case actionTypes['REKYC/GET_REKYC_FLOW'].LOAD:
      draft.rekycFlow.apiStatus = API_STATUS.LOADING;
      draft.rekycFlow.data = null;
      break;

    case actionTypes['REKYC/GET_REKYC_FLOW'].SUCCESS:
      draft.rekycFlow.apiStatus = API_STATUS.SUCCESS;
      draft.rekycFlow.data = action.result.result;
      break;

    case actionTypes['REKYC/GET_REKYC_FLOW'].FAIL:
      draft.rekycFlow.apiStatus = API_STATUS.ERROR;
      draft.rekycFlow.data = REKYC_FLOW.FULL_VERIFICATION;
      break;
    case UPDATE_REKYC_MODAL_STATE:
      draft.verificationModalOpen = action.payload.value;
      draft.modalOpenSource = action.payload.value === true ? action.payload.source : '';
      break;
    case UPDATE_RESTRICTION_INFO_MODAL:
      draft.restrictionsInfoModalOpen = action.payload.value;
      break;
    default:
      break;
  }
}, initialState);

export { rekycVerification };
